import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useParams} from "react-router-dom";
import {baseUrl, ipAddress, userLocation, userName,} from "../Univ.js";
function EditPatient() {
    const {patId} = useParams();
    const [errorMsg, seterrorMsg] = useState("");
    const [succesMsg, setsuccessMsg] = useState("");
    const [patientPhoto, setPatientPhoto] = useState(null);
    const [patientPhotoPreview, setPatientPhotoPreview] = useState("");
    const [cameraOpen, setCameraOpen] = useState(false);
    const [cameraError, setCameraError] = useState("");
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const cameraStreamRef = useRef(null);
    const [registerFormData, setRegisterFormData] = useState({
        my_title: "",
        pat_id: "",
        patient: "",
        gender: "male",
        marital_status: "",
        dob: "",
        age: "",
        abha: "",
        address1: "",
        address2: "",
        areaname: "",
        area_id: "",
        city: "",
        city_id: "",
        state: "",
        state_id: "",
        country: "",
        country_id: "",
        mobile: "",
        occupation: "",
        email: "",
        bloodgroup: "",
        weight: "",
        height: "",
        reltype: "",
        relname: "",
        relcontact: "",
        refered: "",
        refconsultant: "",
        ptype: "",
        addedby: "",
        status: "1",
        location: userLocation,
        ip_add: ipAddress,
        password: "",
    });
    useEffect(() => {
        fetchPatient();
    }, []);
    const startCamera = async () => {
        try {
            setCameraError("");
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                setCameraError("Camera access is not supported by this browser.");
                return;
            }
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: "user", width: {
                        ideal: 1280
                    }, height: {
                        ideal: 720
                    }
                }, audio: false
            });
            cameraStreamRef.current = stream;
            setCameraOpen(true);
            // Wait until video element is rendered
            setTimeout(() => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.play().catch(() => {
                    });
                }
            }, 100);
        } catch (error) {
            console.error("Camera error:", error);
            let message = "Unable to access camera.";
            if (error.name === "NotAllowedError") {
                message = "Camera permission was denied. Please allow camera access in your browser.";
            } else if (error.name === "NotFoundError") {
                message = "No camera was found on this device.";
            } else if (error.name === "NotReadableError") {
                message = "Camera is already being used by another application.";
            }
            setCameraError(message);
        }
    };
    const capturePatientPhoto = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (!video || !canvas) {
            return;
        }
        const width = video.videoWidth;
        const height = video.videoHeight;
        if (!width || !height) {
            Swal.fire({
                title: "Camera Not Ready", text: "Please wait for the camera preview.", icon: "warning"
            });
            return;
        }
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d");
        context.drawImage(video, 0, 0, width, height);
        canvas.toBlob((blob) => {
            if (!blob) {
                return;
            }
            const file = new File([blob], `patient_${Date.now()}.jpg`, {
                type: "image/jpeg"
            });
            setPatientPhoto(file);
            const previewUrl = URL.createObjectURL(blob);
            setPatientPhotoPreview(previewUrl);
            stopCamera();
        }, "image/jpeg", 0.90);
    };
    const stopCamera = () => {
        if (cameraStreamRef.current) {
            cameraStreamRef.current
                .getTracks()
                .forEach(track => track.stop());
            cameraStreamRef.current = null;
        }
        if (videoRef.current) {
            videoRef.current.srcObject = null;
        }
        setCameraOpen(false);
    };
    useEffect(() => {
        return () => {
            if (cameraStreamRef.current) {
                cameraStreamRef.current
                    .getTracks()
                    .forEach(track => track.stop());
            }
        };
    }, []);
    const fetchPatient = async () => {
        try {
            const response = await axios.get(baseUrl + "edit-patient/" + patId);
            setRegisterFormData({
                my_title: response.data.my_title || "",
                pat_id: response.data.pat_id || "",
                patient: response.data.patient || "",
                gender: response.data.gender || "male",
                marital_status: response.data.marital_status || "",
                dob: response.data.dob || "",
                age: response.data.age || "",
                abha: response.data.abha || "",
                address1: response.data.address1 || "",
                address2: response.data.address2 || "",
                areaname: response.data.areaname || "",
                area_id: response.data.area_id || "",
                city: response.data.city || "",
                city_id: response.data.city_id || "",
                state: response.data.state || "",
                state_id: response.data.state_id || "",
                country: response.data.country || "",
                country_id: response.data.country_id || "",
                mobile: response.data.mobile || "",
                occupation: response.data.occupation || "",
                email: response.data.email || "",
                bloodgroup: response.data.bloodgroup || "",
                weight: response.data.weight || "",
                height: response.data.height || "",
                reltype: response.data.reltype || "",
                relname: response.data.relname || "",
                relcontact: response.data.relcontact || "",
                refered: response.data.refered || "",
                refconsultant: response.data.refconsultant || "",
                ptype: response.data.ptype || "",
                addedby: response.data.addedby || "",
                status: response.data.status || "1",
                location: response.data.location || userLocation,
                ip_add: response.data.ip_add || ipAddress,
                password: response.data.password || "",
            });
        } catch (error) {
            console.log(error);
        }
    };
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value,
        });
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            Object.keys(registerFormData).forEach((key) => {
                formData.append(key, registerFormData[key]);
            });
  if (patientPhoto) {
    formData.append("profile_pic", patientPhoto);
}
            formData.append("addedby", userName);
            formData.append("ip_add", ipAddress);
            formData.append("location", userLocation);
            const response = await axios.put(
                baseUrl + "edit-patient/" + patId,
                formData
            );
            if (response.status === 200 || response.status === 201) {
                Swal.fire({
                    title: "Patient Updated Successfully",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setTimeout(() => {
                    window.location.href =
                        "/bill-details/" + registerFormData.pat_id;
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                title: "Error!",
                text: "Failed to update patient.",
                icon: "error",
            });
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h4 className="card-header text-center">
                            Edit Patient
                        </h4>

                        <div className="card-body">
                            {succesMsg && (
                                <p className="text-success">{succesMsg}</p>
                            )}

                            {errorMsg && (
                                <p className="text-danger">{errorMsg}</p>
                            )}

                            <form onSubmit={submitHandler}>
                                <div className="row">
                                    <div className="col-lg-12 mb-4">

                                        <label className="form-label">
                                            Patient Photo
                                        </label>

                                        <div className="d-flex align-items-center gap-3 flex-wrap">

                                            {patientPhotoPreview && (<div>
                                                <img
                                                    src={patientPhotoPreview}
                                                    alt="Patient"
                                                    style={{
                                                        width: "120px",
                                                        height: "120px",
                                                        objectFit: "cover",
                                                        borderRadius: "10px",
                                                        border: "1px solid #ddd"
                                                    }}
                                                />
                                            </div>)}

                                            <div>
                                                <div className="d-flex align-items-center gap-3 flex-wrap">

                                                    {(patientPhotoPreview || registerFormData.profile_pic) && (
    <div>
        <img
            src={
                patientPhotoPreview ||
                (typeof registerFormData.profile_pic === "string"
                    ? registerFormData.profile_pic
                    : URL.createObjectURL(registerFormData.profile_pic))
            }
            alt="Patient"
            style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "1px solid #ddd"
            }}
        />
    </div>
)}

                                                    <div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick={startCamera}
                                                            disabled={cameraOpen}
                                                        >
                                                            <i className="fa-solid fa-camera me-2"></i>
                                                            Take Patient Photo
                                                        </button>

                                                        {patientPhoto && (<div className="small text-success mt-2">
                                                            <i className="fa-solid fa-check me-1"></i>
                                                            Photo captured
                                                        </div>)}

                                                    </div>

                                                </div>
                                                {cameraOpen && (<div
                                                    className="modal d-block"
                                                    tabIndex="-1"
                                                    style={{
                                                        backgroundColor: "rgba(0,0,0,0.75)"
                                                    }}
                                                >

                                                    <div className="modal-dialog modal-lg modal-dialog-centered">

                                                        <div className="modal-content">

                                                            <div className="modal-header">

                                                                <h5 className="modal-title">
                                                                    <i className="fa-solid fa-camera me-2"></i>
                                                                    Patient Photo
                                                                </h5>

                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    onClick={stopCamera}
                                                                ></button>

                                                            </div>

                                                            <div className="modal-body text-center">

                                                                {cameraError ? (<div className="alert alert-danger">
                                                                    <i className="fa-solid fa-triangle-exclamation me-2"></i>
                                                                    {cameraError}
                                                                </div>) : (<video
                                                                    ref={videoRef}
                                                                    autoPlay
                                                                    playsInline
                                                                    muted
                                                                    style={{
                                                                        width: "100%",
                                                                        maxHeight: "500px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "12px",
                                                                        background: "#000"
                                                                    }}
                                                                />)}

                                                                <canvas
                                                                    ref={canvasRef}
                                                                    style={{
                                                                        display: "none"
                                                                    }}
                                                                />

                                                            </div>

                                                            <div className="modal-footer">

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    onClick={stopCamera}
                                                                >
                                                                    <i className="fa-solid fa-xmark me-2"></i>
                                                                    Cancel
                                                                </button>

                                                                {!cameraError && (<button
                                                                    type="button"
                                                                    className="btn btn-success px-4"
                                                                    onClick={capturePatientPhoto}
                                                                >
                                                                    <i className="fa-solid fa-camera me-2"></i>
                                                                    Capture Photo
                                                                </button>)}

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>)}
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label className="form-label">Title</label>

                                        <select
                                            className="form-control"
                                            name="my_title"
                                            value={registerFormData.my_title}
                                            onChange={inputHandler}
                                        >
                                            <option value="">Select</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Ms">Ms</option>
                                            <option value="Master">Master</option>
                                            <option value="Baby">Baby</option>
                                            <option value="Dr">Dr</option>
                                        </select>
                                    </div>

                                    <div className="col-md-5 mb-3">
                                        <label className="form-label">
                                            Patient Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="patient"
                                            value={registerFormData.patient}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <label className="form-label">Age</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="age"
                                            value={registerFormData.age}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">DOB</label>

                                        <input
                                            type="date"
                                            className="form-control"
                                            name="dob"
                                            value={registerFormData.dob}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">Gender</label>

                                        <select
                                            className="form-control"
                                            name="gender"
                                            value={registerFormData.gender}
                                            onChange={inputHandler}
                                        >
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="transgender">
                                                Transgender
                                            </option>
                                        </select>
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">
                                            Marital Status
                                        </label>

                                        <select
                                            className="form-control"
                                            name="marital_status"
                                            value={registerFormData.marital_status}
                                            onChange={inputHandler}
                                        >
                                            <option value="">Select</option>
                                            <option value="single">Single</option>
                                            <option value="married">Married</option>
                                        </select>
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">Mobile</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="mobile"
                                            value={registerFormData.mobile}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">Email</label>

                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            value={registerFormData.email}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">AABHA</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="abha"
                                            value={registerFormData.abha}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Blood Group
                                        </label>
                                        <select
                                            className="form-control"
                                            value={registerFormData.bloodgroup}
                                            onChange={inputHandler}
                                            name="bloodgroup"
                                            id="bloodgroup"
                                        >
                                            <option value="O+">O+</option>
                                            <option value="O-">O-</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="A+">A+</option>
                                            <option value="A-">A-</option>
                                            <option value="AB+">AB+</option>
                                            <option value="AB-">AB-</option>
                                        </select>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <label className="form-label">Weight</label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="weight"
                                            value={registerFormData.weight}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <label className="form-label">Height</label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="height"
                                            value={registerFormData.height}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Address 1
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="address1"
                                            value={registerFormData.address1}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Address 2
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="address2"
                                            value={registerFormData.address2}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">Area</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="areaname"
                                            value={registerFormData.areaname}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">City</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="city"
                                            value={registerFormData.city}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">State</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="state"
                                            value={registerFormData.state}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">Country</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="country"
                                            value={registerFormData.country}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Occupation
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="occupation"
                                            value={registerFormData.occupation}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Relation Type
                                        </label>

                                        <select
                                            className="form-control"
                                            value={registerFormData.reltype}
                                            onChange={inputHandler}
                                            name="reltype"
                                            id="reltype"
                                        >
                                            <option value="Father">Father</option>
                                            <option value="Mother">Mother</option>
                                            <option value="Son">Son</option>
                                            <option value="Daughter">Daughter</option>
                                            <option value="Brother">Brother</option>
                                            <option value="Sister">Sister</option>
                                            <option value="Husband">Husband</option>
                                            <option value="Wife">Wife</option>
                                            <option value="Uncle">Uncle</option>
                                            <option value="Aunty">Aunty</option>
                                            <option value="Attender">Attender</option>
                                        </select>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Relation Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="relname"
                                            value={registerFormData.relname}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Relation Contact
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="relcontact"
                                            value={registerFormData.relcontact}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Referred By
                                        </label>

                                        <select
                                            className="form-control"
                                            name="refered"
                                            value={registerFormData.refered}
                                            onChange={inputHandler}
                                        >
                                            <option value="walkin">Walk-in</option>
                                            <option value="medicalcamp">
                                                Medical Camp
                                            </option>
                                            <option value="friends">
                                                Friends
                                            </option>
                                            <option value="doctor">
                                                Doctor
                                            </option>
                                            <option value="paperad">
                                                Paper Adv
                                            </option>
                                            <option value="others">
                                                Others
                                            </option>
                                        </select>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Ref Consultant
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="refconsultant"
                                            value={registerFormData.refconsultant}
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Patient Type
                                        </label>
                                        <select
                                            className="form-control"
                                            value={registerFormData.ptype}
                                            onChange={inputHandler}
                                            name="ptype"
                                            id="ptype"
                                        >
                                            <option value="Medical">
                                                Medical Management
                                            </option>

                                            <option value="Surgical">
                                                Surgical Management
                                            </option>
                                        </select>

                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Password
                                        </label>

                                        <input
                                            type="password"
                                            className="form-control"
                                            name="password"
                                            value={registerFormData.password}
                                            onChange={inputHandler}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Status
                                        </label>

                                        <select
                                            className="form-control"
                                            name="status"
                                            value={registerFormData.status}
                                            onChange={inputHandler}
                                        >
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-success"
                                    >
                                        Update Patient
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default EditPatient;